import { render, staticRenderFns } from "./BaseLoginForUser.vue?vue&type=template&id=ec278ba2&"
import script from "./BaseLoginForUser.vue?vue&type=script&lang=js&"
export * from "./BaseLoginForUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports